import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { CustomOutputIconsComponent } from '../custom-output-icons/custom-output-icons.component';
import { SnapshotService } from '../../Services/snapshot.service';
import * as _ from 'lodash';
import { CustomsnapshotService } from '../../Services/customsnapshot.service';
import { LoaderService } from 'src/app/common/services/loader.service';
import { BarserviceService } from '../../../snapshot/custom-snapshot-chart-modules/barchart/barchart/barservice.service';
import { ChatbotService } from 'src/app/common/services/chatbot.service';
import { InsightspopupService } from 'src/app/common/services/insightspopup.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-custom-widget-output',
  templateUrl: './custom-widget-output.component.html',
  styleUrls: ['./custom-widget-output.component.css'],
})
export class CustomWidgetOutputComponent implements OnChanges, OnDestroy {
  hideCharts: boolean = false;
  isSevenWidgetLayout: boolean = false;
  isThreeWidgetLayout: boolean = false;
  insightKeys: any;
  InsightsResponse: any;
  //  isInsightspopupOpen: boolean=false;
  showSnapshot: boolean = false;
  isLoading: boolean = true;
  // insightsVal: any;

  constructor(
    public _configService: SnapshotService,
    private _configCustomService: CustomsnapshotService,
    private loader: LoaderService,
    private barService: BarserviceService,
    private apiService: ChatbotService,
    private _insightsSerive: InsightspopupService,
    private _cdr: ChangeDetectorRef
  ) {}
  @Input() outputData: any = {};
  isInsightspopupOpen: any;
  insightsVal: any;
  insightsData: any;
  @Input() sigIndex: string = '';
  @Input() isIndex: boolean = false;
  @Output() pageCounterChanged = new EventEmitter<number>();
  @Output() globalColorMapChanged = new EventEmitter<{ [key: string]: string }>();
  @ViewChild('inforRibbon', { static: false }) inforRibbon:
    | ElementRef
    | undefined;
  @ViewChildren(CustomOutputIconsComponent) iconComponents!: QueryList<CustomOutputIconsComponent>;
  // colorPalette = this.barService.color1;
  colorPalette =
    this.barService.color1?.length > 0
      ? this.barService.color1
      : this.barService.commonchartmodules.color1;
  linearGradientsColorPalette = this.barService.linearGradients;
  globalColorMap: { [key: string]: string } = {};
  brandcolors =  this.barService.brandcolors?.length > 0
      ? this.barService.brandcolors
      : this.barService.commonchartmodules.brandcolors;
  filteredColorPalette: string[] = [];
  globalColorMapLinearGradient: { [key: string]: string } = {};
  // Stable registry: persists key→color assignments across payload changes so
  // re-rendering with a modified payload does not reassign colors to existing keys.
  private _stableColorRegistry: { [key: string]: string } = {};
  private _stableLinearGradientRegistry: { [key: string]: string } = {};
  private _stableColorCounter: number = 0;
  mounted = false;
  singleInsight: any = null;
  private subscription!: Subscription;

  /**
   * Stores brandcolors values in globalColorMap format
   * Converts from brandcolors array format to { [key: string]: string } format
   * Re-reads the palette because this component survives snapshot-type changes.
   */
  storeBrandColorsInGlobalColorMap(): void {
    this.filterColorPalette();
    if (this.brandcolors && Array.isArray(this.brandcolors)) {
      this.brandcolors.forEach((brand: any) => {
        if (brand.BrandName && brand.HexCode) {
          this.globalColorMap[brand.BrandName] = brand.HexCode;
        }

      });
    }
    // Emit the updated globalColorMap to parent component
    this.globalColorMapChanged.emit(this.globalColorMap);
  }

  /**
   * Filters the color palette to remove colors that already exist in brandcolors
   * This prevents duplicate colors and ensures brand colors take precedence
   */
  filterColorPalette(): void {
    // Re-read from barService so any Excel upload after init is picked up
    this.colorPalette = this.barService.color1?.length > 0
      ? this.barService.color1
      : this.barService.commonchartmodules.color1;
    this.brandcolors = this.barService.brandcolors?.length > 0
      ? this.barService.brandcolors
      : this.barService.commonchartmodules.brandcolors;
    this.linearGradientsColorPalette = this.barService.linearGradients;

    if (!this.colorPalette || !Array.isArray(this.colorPalette)) {
      this.filteredColorPalette = [];
      return;
    }

    this.filteredColorPalette = [...this.colorPalette];
  }

  /**
   * Gets a color from the filtered color palette with safe index wrapping
   */
  getFilteredColor(index: number): string {
    if (!this.filteredColorPalette || this.filteredColorPalette.length === 0) {
      // Fallback to original palette if filtered palette is empty
      return this.colorPalette && this.colorPalette.length > 0 
        ? this.colorPalette[index % this.colorPalette.length] 
        : '#000000'; // Ultimate fallback
    }
    return this.filteredColorPalette[index % this.filteredColorPalette.length];
  }

  private isRenderableStackBarEntry(entry: any): boolean {
    const value = entry?.data;
    return value !== null &&
      value !== undefined &&
      String(value).trim().toUpperCase() !== 'NA' &&
      !(parseFloat(value) < 0);
  }

  private stackBarStableKey(widget: any, colorKey: string): string {
    return `${widget.previewChartPostion ?? widget.widget_name}::${colorKey}`;
  }

  /** Colour key of a stack layer: the cohort when transposed, otherwise the metric. */
  private stackBarColorKey(metricValue: any, entry: any, isTransposeOn: boolean): string {
    return isTransposeOn ? entry.colChild : entry.rowChild || entry.colChild;
  }

  /**
   * Resolves the colour of every stack layer of a widget up front.
   *
   * Two constraints have to hold at once: layers are drawn on top of each other, so no two of
   * them may share a colour, and a layer already on screen must keep its colour when the
   * payload changes. Selecting an index or significance reference can add a cohort, which in
   * a transposed stack becomes an extra layer. Assigning colours in payload order would let
   * that new layer claim a slot an existing layer owns and push every other layer along, so
   * layers seen before are served from the registry first and only the rest consume palette
   * slots that are still free.
   */
  private buildStackBarColorMap(
    widget: any,
    metricValues: any[],
    isTransposeOn: boolean,
    widgetColorMap: { [key: string]: string },
    widgetColorMapLinearGradient: { [key: string]: string }
  ): void {
    const colorKeys: string[] = [];
    const payloadColors: { [key: string]: string } = {};

    (metricValues || []).forEach((metricValue: any) => {
      if (metricValue.isAdditionalKPI) return;
      (metricValue.data || []).forEach((entry: any) => {
        if (!this.isRenderableStackBarEntry(entry)) return;
        const colorKey = this.stackBarColorKey(metricValue, entry, isTransposeOn);
        if (!colorKey) return;
        if (!colorKeys.includes(colorKey)) colorKeys.push(colorKey);
        if (entry.color && !payloadColors[colorKey]) payloadColors[colorKey] = entry.color;
      });
    });

    const takenColors = new Set<string>();
    const unresolvedKeys: string[] = [];
    colorKeys.forEach((colorKey) => {
      const stableKey = this.stackBarStableKey(widget, colorKey);
      const known = this._stableColorRegistry[stableKey] || payloadColors[colorKey];
      if (known && !takenColors.has(known)) {
        widgetColorMap[colorKey] = known;
        this._stableColorRegistry[stableKey] = known;
        takenColors.add(known);
      } else {
        unresolvedKeys.push(colorKey);
      }
    });

    const paletteLength = this.filteredColorPalette?.length || this.colorPalette?.length || 0;
    let paletteIndex = 0;
    unresolvedKeys.forEach((colorKey) => {
      let offset = 0;
      let color = this.getFilteredColor(paletteIndex);
      while (takenColors.has(color) && offset < paletteLength) {
        offset++;
        color = this.getFilteredColor(paletteIndex + offset);
      }
      paletteIndex += offset + 1;
      takenColors.add(color);
      widgetColorMap[colorKey] = color;
      this._stableColorRegistry[this.stackBarStableKey(widget, colorKey)] = color;
    });

    colorKeys.forEach((colorKey, index) => {
      widgetColorMapLinearGradient[colorKey] = this.getStableStackBarGradient(
        widget,
        colorKey,
        undefined,
        index
      );
    });
  }

  private getStableStackBarGradient(widget: any, colorKey: string, incomingGradient: any, colorIndex: number): any {
    const stableKey = `${widget.previewChartPostion ?? widget.widget_name}::${colorKey}`;
    if (!this._stableLinearGradientRegistry[stableKey]) {
      this._stableLinearGradientRegistry[stableKey] =
        incomingGradient || this.linearGradientsColorPalette[colorIndex % this.linearGradientsColorPalette.length];
    }
    return this._stableLinearGradientRegistry[stableKey];
  }

  private _decimalConfigSub?: Subscription;

  ngOnInit(): void {
    // Filter color palette to remove colors that already exist in brandcolors
    this.filterColorPalette();
    this._decimalConfigSub = this._configService.decimalConfigApplied$.subscribe(() => {
      if (this.outputData && Object.keys(this.outputData).length > 0) {
        this.handleSectionOrSubsectionChange();
      }
    });

    // ✅ subscribe to snapshot observable
    this._insightsSerive.isSingleInsightsSnapshot$.subscribe((singleInsight)=>{
      this.singleInsight = singleInsight;
      this._cdr.detectChanges();
    });
    
    this.subscription = this._insightsSerive.isInsightsSnapshot$.subscribe(
      (snapshot) => {
        this.isInsightspopupOpen = snapshot['show'];
        if (snapshot['show'] == true) {
          try {
            // snapshot.message assumed as JSON string
            this.insightsData = JSON.parse(snapshot.message);

            this.insightKeys = Object.keys(this.insightsData);

            this.insightKeys.forEach((e: any) => {
              try {
                //child json parsing
                if (this.insightsData?.[e]?.Value.indexOf('```json') != -1) {
                  let parseData = this.insightsData[e]['Value']
                    .replace(/^```\s*/, '') // remove leading ``` (and optional newline)
                    .replace(/^json\s*/, '') // remove leading json (and optional newline)
                    .replace(/```$/, '');

                  this.insightsData[e]['Value'] = this.extractResponse(e, parseData);
                }

                this.insightsData[e]['Value'] = (this.insightsData?.[e]?.Value || '')
                  .split('\n')
                  .filter((line: any) => line.trim() !== '')
                  .map((line: any) => line.replace(/[*-]/g, '').trim());
              } catch (keyError) {
                this.insightsData[e]['Value'] = 'No Data Available';
              }
            });

            if (snapshot.message != 'loading') this.isLoading = false;
          } catch (err) {
            console.error(
              'Invalid JSON in snapshot message:',
              snapshot.message,
              err
            );
            this.insightsData = undefined;
            this.insightKeys = undefined;
            if (snapshot.message != 'loading') this.isLoading = false;
          }
        } else {
          this.insightsData = undefined;
          this.insightKeys = undefined;
        }

        if (this.isInsightspopupOpen) {
          setTimeout(() => (this.mounted = true), 0);
        } else {
          this.mounted = false;
        }
      }
    );
  } 
  private extractResponse(ekey: string, data: any): string {
    let parseData = JSON.parse(data);
    //json property parsing
    let parseDataKeys = Object.keys(parseData);
    if (parseDataKeys.length > 0) {
      let value = '';
      Object.keys(parseData).forEach((xKey: any) => {
        if (parseData && parseData[xKey]) {
          parseData[xKey] = Array.isArray(parseData[xKey])
            ? parseData[xKey].join('\n')
            : parseData[xKey];
          value += `${parseData[xKey]} \n`;
        }
      });
      this.insightsData[ekey]['Value'] =
        (value ?? '') === '' ? this.insightsData[ekey]['Value'] : value;
    } else {
      this.insightsData[ekey]['Value'] = this.insightsData[ekey]['Value'];
    }

    return this.insightsData[ekey]['Value'];
  }

  ngOnChanges(changes: SimpleChanges) {
    this.isLoading = true;
      // if (changes['singleInsight']) {
    // }
    // this.insightsData = this.insightsVal != undefined ? JSON.parse(this.insightsVal) : undefined;

    // this.insightKeys = this.insightsVal != undefined? Object.keys(this.insightsData): undefined;

    // if (this.insightsVal != undefined) {
    // this.insightKeys.forEach((e: any) => {
    // this.insightsData[e]['Value'] = (this.insightsData?.[e]?.Value || '')
    // .split('\n')
    // .filter((line: any) => line.trim() !== '')
    // .map((line: any) => line.replace(/[*-]/g, '').trim());});}

    sessionStorage.setItem('dataLoaded', 'true');
    //Perform an operation if either pageData or widgetData changes
    // Use a single needsRefresh flag so that simultaneous input changes
    // (outputData + sigIndex) only trigger ONE outputDataRefresh call.
    let needsRefresh = false;
    if (changes['outputData']) {
      this.pageCount = this._configCustomService.pageCount;
      if (Object.keys(changes['outputData'].currentValue).length != 0) {
        needsRefresh = true;
      }
    }

    if (changes['sigIndex'] && this.sigIndex != 'sig') {
      if (Object.keys(this.outputData).length > 0) {
        needsRefresh = true;
      }
    }

    if (needsRefresh) {
      this.outputDataRefresh();
    }

    if (this.isInsightspopupOpen) {
      setTimeout(() => (this.mounted = true), 0);
    } else {
      this.mounted = false;
    }
  }

  outputDataRefresh() {
    if (!this._configService.decimalPointConfig) {
      // Try alreadySavedSnapshotData (set by Module Config page in same session)
      const d = this._configService.alreadySavedSnapshotData?.decimal_point_configuration
             ?? (this._configService as any).outputSnapshotData?.decimal_point_configuration;
       console.log('d =', d);
      if (d) this._configService.decimalPointConfig = {
        tabular: d.tabular ?? 'chart',
        charts:  d.charts  ?? 'chart',
        excel:   d.excel   ?? 'chart',
        ppt:     d.ppt     ?? 'chart',
      };
      console.log(
      'After setting decimalPointConfig:',
      this._configService.decimalPointConfig
    );
    }
    this.loader.showLoader();
    this.hideCharts = true;
    this.data = [];
    this.gridData = [];
    this.outputPageData = [];
    // Refresh color filtering when data is refreshed
    this.filterColorPalette();
    this.handleSectionOrSubsectionChange();
  }

  outputPageData: any = [];
  datafromLayout: any = [];
  data: any = [];
  pagesConfiguredFromLayout: any;
  totalNumberOfCharts: number = 0;
  columnPerRowCount: number = 0;
  baseSelected: string = 'total base';
  showGlobalDefaultPopup: boolean = false;
  dontShowAgain: boolean = false;
  private globalDefaultPopupTimeout: any; // timeout ref for auto-dismiss
  selectedDataFormat: string = '';
  isTotalBase: boolean = false;
  selected_study: string = '';
  selected_client: string = '';
  DefaultConfidenceLevel: string = '';
  @Input() selectedWeight: string = '';

  //  chartList: {
  //   widgetName: string,
  //   image: string
  // }[] = [];
  chartList: any[] = [];

  gridTempleteColumns: string = '';
  arktabaccess: boolean = false;
  private _sectionRefreshTimer: any = null;
  
  get noDataAvailable(): boolean {
  return this.data?.every((d: any) => d.noData === true);
}
  handleSectionOrSubsectionChange() {
    // Cancel any in-flight deferred render to prevent stale data from
    // a previous call overwriting the latest data.
    if (this._sectionRefreshTimer) {
      clearTimeout(this._sectionRefreshTimer);
      this._sectionRefreshTimer = null;
    }
    this.chartList = [];
    this.pageCount = this._configCustomService.pageCount; //on change of section/subsection move to page 1
    this.disableLeftClick = true;
    this.disableRightClick = false;
    this.updateNavigationButtonsState();
    let pages = [];
    for (let i = 0; i < this.outputData.pageData.length; i++) {
      pages.push({
        page: this.outputData.pageData[i].key,
        selectedLayout: this.outputData.pageData[i].value, // Default value will be `null`
        disabled: false,
        dropdownOpen: false, // Add a flag to track dropdown state
        layout: [
          { label: 'Select a layout', value: null, selected: false },
          {
            label: '6 Widget Layout',
            value: 6,
            url: '../../../../../assets/ImagesSnapshot/Public/sixWidget_inactive.png',
            activeurl:
              '../../../../../assets/ImagesSnapshot/Public/sixWidget_active.png',
            selected: this.outputData.pageData[i].value == 6 ? true : false,
          },
          {
            label: '4 Widget Layout',
            value: 4,
            url: '../../../../../assets/ImagesSnapshot/Public/fourWidget_inactive.png',
            activeurl:
              '../../../../../assets/ImagesSnapshot/Public/fourWidget_active.png',
            selected: this.outputData.pageData[i].value == 4 ? true : false,
          },
        ],
      });
    }
    this.datafromLayout = pages;

    let sum = 0;
    let count = 0;
    this.datafromLayout.forEach((val: any) => {
      if (val.selectedLayout != null) {
        sum = sum + val.selectedLayout;
        count++;
      }
    });
    //If no. of pages configured in layout is only one then disable right pagination click
    if (count == 1) {
      this.disableRightClick = true;
    }
    //this.totalNumberOfCharts=this.snapShotService.LayoutDiv;
    this.pagesConfiguredFromLayout = count;
    this.totalNumberOfCharts = sum;
    this.columnPerRowCount = sum;
    
    for (let i = 0; i < this.totalNumberOfCharts; i++) {
      this.chartList.push({
        customizationProperties: '',
        metric: [],
        previewChartPostion: -1,
        widgetParentChartType: '',
        widget_name: '',
        widgetchart_name: '',
      });
    }

    //Adding widget details in chartList
    for (let i = 0; i < this.outputData.widgetData.length; i++) {
      if (this.outputData.widgetData[i].previewChartPostion == 0) {
        continue;
      }
      if (this.outputData.widgetData[i].previewChartPostion) {
  this.chartList[this.outputData.widgetData[i].previewChartPostion - 1] =
    this.outputData.widgetData[i];
}
    }
    this.hideCharts = true;

    this._sectionRefreshTimer = setTimeout(() => {
      this._sectionRefreshTimer = null;
      this.createInitialChartList();
      this.data = this._configService.selectedcompareacrossOption.includes(
        'Multiple'
      )
        ? this.paginatedDataMultiple()
        : this.paginatedData();
        if (this.columnPerRowCount === 7) {
          this.data = Array(7)
            .fill(null)
            .map((_, i) => this.data[i] || {});
        }

      // Set isSevenWidgetLayout based on current page's widget count
      this.isSevenWidgetLayout = this.columnPerRowCount === 7;
   
      this._configService.InsightsData = this.data;
      if (this._configService.selectedcompareacrossOption.includes('Multiple')) {
        this.multimetricselect = this.data.some(
          (d: any) => d.metric?.[0]?.metric_value?.length > 1
        );
      } else {
        this.multimetricselect = false;
      }
      if (
        this.data.length == 1 &&
        this.data[0].widgetchart_name == 'FUNNEL CHART'
      ) {
        this.prepareGridForMultiFunnel(this.data[0]);
      }

      this.hideCharts = false;
      this.loader.hideLoader();
      const skipPopup =
        localStorage.getItem('dontShowGlobalDefaultPopup') === 'true';
      const alreadyShownThisSession = sessionStorage.getItem('shownGlobalDefaultPopup') === 'true';
      if (
        this._configService.isGlobalDefaultSelectionEnabled &&
        this._configService.showGlobalDefaultPopup &&
        !skipPopup &&
        !alreadyShownThisSession
      ) {
        this.showGlobalDefaultPopup = true;
        this.startGlobalDefaultPopupTimer();
        sessionStorage.setItem('shownGlobalDefaultPopup', 'true');
      }
    }, 1000);
  }
  createInitialChartList() {
    // ;
    // for (let i = 0; i < this.totalNumberOfCharts; i++) {
    //   this.chartList.push({
    //     widgetName: "",
    //     image: ""
    //   });
    // }
    //Based on page number assign this.columnPerRowCount
    let page = this.datafromLayout.filter((item: any) => {
      return JSON.stringify(item).includes('Page ' + this.pageCount);
    });
    if (!page || page.length === 0) {
      return;
    }
      this.columnPerRowCount = page[0].selectedLayout;

      this.gridTempleteColumns = '';
      this.isSevenWidgetLayout = false;
      this.isThreeWidgetLayout = false;
      if (this.columnPerRowCount === 2) {
        this.gridTempleteColumns = '100%'; // ← 1 column, widgets stack vertically
      } 
      else if (this.columnPerRowCount === 7) {
      this.isSevenWidgetLayout = true;
      }
      else if (this.columnPerRowCount === 3) {   
        this.isThreeWidgetLayout = true;
      }
      else {
        for (let i = 0; i < this.columnPerRowCount / 2; i++) {
          this.gridTempleteColumns +=
            this.calculateValuePerDivision(this.columnPerRowCount / 2) + '% ';
      }

      console.log('gridTempleteColumns', this.gridTempleteColumns);
    }
  }
  calculateValuePerDivision(numDivs: any) {
    const k = 99; // considering for 2 always 27.5.So reciprocal method: 27.5=k/2=>55.
    //so now for 3 it will be 55/3 ,for 4 it will be 55/4 and so on....
    return k / numDivs;
  }
  outputdata: any; //dummy
  chartData: any;
  paginatedData() {
    this.globalColorMap = {};
    this.storeBrandColorsInGlobalColorMap();
    this.globalColorMapLinearGradient = {};
    this.outputdata = this._configService.standardSnapOutputData; //remove later
    //this.chartData=this._configService.standardSnapOutputData;
    //this.chartList1=this.chartList;
    let start = 0;
    if (this.pageCount == 0) {
      start = 0;
    } else {
      for (let i = 0; i < this.pageCount - 1; i++) {
        start = start + this.datafromLayout[i].selectedLayout;
      }
    }
    // const start = (this.pageCount - 1) * this.columnPerRowCount;
    const end = start + this.columnPerRowCount;
    let chartlist = this.chartList.slice(start, end);
    let pageCounter = 1;
    let item = chartlist;
    let items = _.cloneDeep(chartlist);

    items.forEach((item: any) => {
      if (item.widgetchart_name == 'Table') {
        let m = JSON.parse(item.customizationProperties);
        item.enableDataBars = m.enableDataBars;
        const props = JSON.parse(item.customizationProperties || '{}');
        props.isBarDataEnable = m.enableDataBars;
        props.decimalRoundOff = this._configService.getEffectiveDecimal(item.widgetchart_name, 'ui', props.decimalRoundOff);
        item.customizationProperties = JSON.stringify(props);
        item.toggleButton = true;
      } else {
        const props = JSON.parse(item.customizationProperties || '{}');
        props.decimalRoundOff = this._configService.getEffectiveDecimal(item.widgetchart_name, 'ui', props.decimalRoundOff);
        item.customizationProperties = JSON.stringify(props);
      }
      item.metric.forEach((itemLev1: any) => {
        if (itemLev1.metric_group == '' && itemLev1.metric_value.length > 0) {
          let allMetricsNull = true;
          itemLev1.metric_value.forEach((metric: any) => {
            const outputRow = _.cloneDeep(
              this.outputdata.find(
                (row: any) =>
                  row.rowChild.includes(metric.option) &&
                  row.widgetNumber == item.widgetNumber &&
                  item.widgetName == row.widgetName
              )
            );
            //const outputRow = _.cloneDeep(this.outputdata.find((row: any) => row.rowChild.includes(metric.option) && row.colChild.includes(metric.colChild) && row.widgetNumber == item.previewChartPostion && item.widget_name == row.widgetName));
            if (
              this.baseSelected.toLowerCase() != 'total base'
                ? outputRow?.answerWeightedShare !== null
                : outputRow?.totalWeightedShare !== null
            ) {
              allMetricsNull = false;
            }
          });
          if (allMetricsNull) {
            item.metric = [];
            item.noData = true;
          }
        } else if (
          itemLev1.metric_group != '' &&
          itemLev1.metric_value.length == 0
        ) {
          let allMetricsNull = true;
          const metrics = this._configService.standardSnapOutputData.filter(
            (row: any) =>
              row.widgetNumber == item.widgetNumber &&
              item.widgetName == row.widgetName
          );
          if (metrics.length > 0) {
            metrics.forEach((metric: any, index: number) => {
              if (
                this.baseSelected.toLowerCase() != 'total base'
                  ? metric?.answerWeightedShare !== null
                  : metric?.totalWeightedShare !== null
              ) {
                allMetricsNull = false;
              }
            });
            if (allMetricsNull) {
              item.metric = [];
              item.noData = true;
            }
          }
        } else if (
          itemLev1.metric_group == '' &&
          itemLev1.metric_value.length == 0
        ) {
          item.metric = [];
        }
      });
    });

    items.forEach((widget) => {
      if (!widget.widget_name || !widget.metric || widget.metric.length === 0)
        return;
      if (this._configService.selectedSnapshotType === 'Audience Snapshot') {
        const brandOption = this._configService?.finalLeftPanelSubmitObject?.previewData?.Audiencebrand?.[0]?.option;
        if (brandOption) {
          widget.widget_name = `${widget.widget_name}`;
          widget.brand_name = brandOption;
        }
      }
      // Reset color counter for each widget so every widget starts at color[0]
      
      var widgetColorMap: { [key: string]: string } = {};
      const widgetColorMapLinearGradient: { [key: string]: string } = {};
      let widgetColorIndex = 0;

      // Detect transpose state from customizationProperties.
      let isTransposeOn = false;
      if (widget.customizationProperties) {
        try {
          const _props = JSON.parse(widget.customizationProperties);
          const _transposeValue = _props.StackFormat ?? _props.Transpose ?? _props.additionalGroup?.Transpose;
          if (_transposeValue !== undefined && _transposeValue !== null) {
            isTransposeOn = _transposeValue.toString().trim() === 'On';
          }
        } catch {}
      }
      const isClusterBarWidget = widget.widgetchart_name === 'Vertical Cluster Bar' ||
                                 widget.widgetchart_name === 'Horizontal Cluster Bar';
      const isStackBarWidget = widget.widgetchart_name === 'Vertical Stack Bar' ||
                               widget.widgetchart_name === 'Horizontal Stack Bar';
      const isPieChartWidget = widget.widgetchart_name === '01/PIE CHART' ||
                               widget.widgetchart_name === '05/PIE CHART' ||
                               widget.widgetchart_name === '09/PIE CHART';
      // 05 pie draws one ring per metric. A brand/cohort key paints every ring the same colour.
      const isRingPie = widget.widgetchart_name === '05/PIE CHART';
      // Transposed cluster bars render each metric as its own series, so each metric
      // needs a distinct colour. Metrics can span multiple groups, so flatten them.
      const metricValues = isClusterBarWidget
        ? widget.metric.flatMap((mg: any) => mg.metric_value || [])
        : widget.metric[0].metric_value;

      if (isStackBarWidget) {
        this.buildStackBarColorMap(widget, metricValues, isTransposeOn, widgetColorMap, widgetColorMapLinearGradient);
      }

      metricValues.forEach((metricValue: any) => {
        metricValue.data = metricValue.data.map((entry: any) => {
          const colChild = entry.colChild;
          const rowChild = entry.rowChild;
          let colorKey = colChild;
          const isClusterBar = isClusterBarWidget;
        
          const isStackBar = isStackBarWidget;         
          if (isStackBar && !this.isRenderableStackBarEntry(entry)) {
            return entry;
          }
          // The additional KPI is rendered as a grey overlay marker instead of a stack layer,
          // so it must not claim a palette colour from the layers.
          if (isStackBar && metricValue.isAdditionalKPI) {
            return entry;
          }
const isSingleOrAudience = this._configService.selectedSnapshotType == 'Single Brand' || 
    (this._configService.selectedSnapshotType == 'Audience Snapshot' );

if (isRingPie) {
  // Each ring is a metric, so the key must change with the metric even when the brand does not.
  colorKey = metricValue.option || rowChild || colChild;
} else if (isPieChartWidget) {
  // Pie slices represent brands/categories, so keep their colors tied to colChild.
  colorKey = colChild;
} else if (isClusterBar && isTransposeOn) {
  // Transposed cluster bar: each metric is a series and needs its own color
  colorKey = rowChild || colChild;
} else if (isStackBar && isTransposeOn) {
  // Transposed stack bar: each segment (colChild) is a stack layer and needs its
  // own color. Keep this even for Single Brand/Audience snapshots, where rowChild
  // would otherwise collapse every segment to a single colour.
  colorKey = colChild;
} else if (isStackBar) {
  // Non-transposed stack bar: the metric is the stack layer, so every cohort of a
  // metric shares one colour. Including colChild here would tie the layer colour to
  // how many cohorts are on screen, so adding one would repaint every layer.
  colorKey = rowChild || colChild;
} else if ((isClusterBar) && isSingleOrAudience) {
  // Each audience segment (colChild) needs its own color
  colorKey = colChild;  // e.g. "Gender|Male", "Gender|Female"
} else if (isSingleOrAudience ) {
  colorKey = `${rowChild}_${colChild}`;
} else {
  colorKey = colChild;
}
          // const isSingleOrAudience = this._configService.selectedSnapshotType == 'Single Brand' || 
          //     this._configService.selectedSnapshotType == 'Audience Snapshot';
              
          // if (isSingleOrAudience) {
          //   colorKey = `${rowChild}`;
          // }
          let rowChildKey = colChild;

          // Assign colorKey FIRST so the displayed color always claims the lowest slot
          if (!widgetColorMap[colorKey]) {
            if (isStackBarWidget) {
              // buildStackBarColorMap already resolved every layer of this widget; this only
              // covers a key it could not see.
              widgetColorMap[colorKey] = entry.color || this.getFilteredColor(widgetColorIndex);
              widgetColorMapLinearGradient[colorKey] = this.getStableStackBarGradient(widget, colorKey, entry.colorLinearGradient, widgetColorIndex);
              widgetColorIndex++;
            } else if (!isRingPie && entry.color) {
              widgetColorMap[colorKey] = entry.color;
              widgetColorMapLinearGradient[colorKey] =
                entry.colorLinearGradient || this.linearGradientsColorPalette[widgetColorIndex % this.linearGradientsColorPalette.length];
              widgetColorIndex++;
            } else if (this.globalColorMap[colorKey]) {
              widgetColorMap[colorKey] = this.globalColorMap[colorKey];
              widgetColorMapLinearGradient[colorKey] = this.globalColorMapLinearGradient[colorKey];
            }
             else {
              widgetColorMap[colorKey] = this.getFilteredColor(widgetColorIndex);
              widgetColorMapLinearGradient[colorKey] = this.linearGradientsColorPalette[widgetColorIndex % this.linearGradientsColorPalette.length];
              widgetColorIndex++;
            }
          }

          const color = (isStackBar || isRingPie) ? widgetColorMap[colorKey] : entry.color || widgetColorMap[colorKey];
          const colorLinearGradient = (isStackBar || isRingPie) ? widgetColorMapLinearGradient[colorKey] : entry.colorLinearGradient || widgetColorMapLinearGradient[colorKey];
          
          let data = entry.data;
          let data2 = entry.data2;
          if (entry.CalculationType?.toLowerCase() === 'meanpercentage') {
            data = data == null || data === 'NA' ? data : data * 100;
            data2 = data2 == null || data2 === 'NA' ? data2 : data2 * 100;
          }

          return {
            ...entry,
            data,
            data2,
            color,
            colorLinearGradient,
          };
        });
      });
      // Merge widget-local assignments into global map for legend compatibility
      
      Object.assign(this.globalColorMap, widgetColorMap);
      Object.assign(this.globalColorMapLinearGradient, widgetColorMapLinearGradient);
    });

    this._configCustomService.pageCount = this.pageCount;
    this._configService.paginatedItems = items;
     if (typeof window !== undefined) {
        (window as any)['jsonobject'] = items;
      }
    // publish global maps to SnapshotService so other components (charts) can consume them
    this._configService.setGlobalColorMap(this.globalColorMap);
    this._configService.setGlobalColorMapLinearGradient(this.globalColorMapLinearGradient);
    // Emit the updated globalColorMap to parent component
    this.globalColorMapChanged.emit(this.globalColorMap);
    items.forEach((w: any) => { w.legendItems = this.getLegendItems(w); w.legendTable = this.getLegendTable(w); });
    return items;
  }

  paginatedDataMultiple() {
    this.globalColorMap = {};
    this.storeBrandColorsInGlobalColorMap();
    this.globalColorMapLinearGradient = {};
    this.outputdata = this._configService.standardSnapOutputData; //remove later
    let start = 0;
    if (this.pageCount == 0) {
      start = 0;
    } else {
      for (let i = 0; i < this.pageCount - 1; i++) {
        start = start + this.datafromLayout[i].selectedLayout;
      }
    }
    // const start = (this.pageCount - 1) * this.columnPerRowCount;
    const end = start + this.columnPerRowCount;
    let chartlist = this.chartList.slice(start, end);
    let pageCounter = 1;
    let item = chartlist;
    let items = _.cloneDeep(chartlist);

    items.forEach((item: any) => {
      if (item.widgetchart_name == 'Table') {
        let m = JSON.parse(item.customizationProperties);
        item.enableDataBars = m.enableDataBars;
        const props = JSON.parse(item.customizationProperties || '{}');
        props.isBarDataEnable = m.enableDataBars;
        props.decimalRoundOff = this._configService.getEffectiveDecimal(item.widgetchart_name, 'ui', props.decimalRoundOff);
        item.customizationProperties = JSON.stringify(props);
        item.toggleButton = true;
      } else {
        const props = JSON.parse(item.customizationProperties || '{}');
        props.decimalRoundOff = this._configService.getEffectiveDecimal(item.widgetchart_name, 'ui', props.decimalRoundOff);
        item.customizationProperties = JSON.stringify(props);
      }

      item.metric.forEach((itemLev1: any) => {
        if (itemLev1.metric_group == '' && itemLev1.metric_value.length > 0) {
          let allMetricsNull = true;
          itemLev1.metric_value.forEach((metric: any) => {
            const outputRow = _.cloneDeep(
              this.outputdata.find(
                (row: any) =>
                  metric.option != null && row.rowChild.includes(metric.option) &&
                  metric.colChild != null && row.colChild.includes(metric.colChild) &&
                  row.widgetNumber == item?.previewChartPostion &&
                  item.widget_name == row.widgetName
              )
            );
            if (
              this.baseSelected.toLowerCase() != 'total base'
                ? outputRow?.answerWeightedShare !== null
                : outputRow?.totalWeightedShare !== null
            ) {
              allMetricsNull = false;
            }
          });
          if (allMetricsNull) {
            item.metric = [];
            item.noData = true;
          }
        } else if (
          itemLev1.metric_group != '' &&
          itemLev1.metric_value.length == 0
        ) {
          let allMetricsNull = true;
          const metrics = this._configService.standardSnapOutputData.filter(
            (row: any) =>
              row.widgetNumber == item.widgetNumber &&
              item.widgetName == row.widgetName
          );
          if (metrics.length > 0) {
            metrics.forEach((metric: any, index: number) => {
              if (
                this.baseSelected.toLowerCase() != 'total base'
                  ? metric?.answerWeightedShare !== null
                  : metric?.totalWeightedShare !== null
              ) {
                allMetricsNull = false;
              }
            });
            if (allMetricsNull) {
              item.metric = [];
              item.noData = true;
            }
          }
        } else if (
          itemLev1.metric_group == '' &&
          itemLev1.metric_value.length == 0
        ) {
          item.metric = [];
        }
      });
    });
    this._configCustomService.pageCount = this.pageCount;
    items.forEach((widget) => {
      if (!widget.widget_name || !widget.metric || widget.metric.length === 0)
        return;
      if (this._configService.selectedSnapshotType === 'Audience Snapshot') {
        const brandOption = this._configService?.finalLeftPanelSubmitObject?.previewData?.Audiencebrand?.[0]?.option;
        if (brandOption) {
          widget.widget_name = `${widget.widget_name}`;
          widget.brand_name = brandOption;
        }
      }
      // Reset color counter for each widget so every widget starts at color[0]
      
      const widgetColorMap: { [key: string]: string } = {};
      const widgetColorMapLinearGradient: { [key: string]: string } = {};
      let widgetColorIndex = 0;

      // Detect transpose state from customizationProperties.
      let isTransposeOn = false;
      if (widget.customizationProperties) {
        try {
          const _props = JSON.parse(widget.customizationProperties);
          const _transposeValue = _props.StackFormat ?? _props.Transpose ?? _props.additionalGroup?.Transpose;
          if (_transposeValue !== undefined && _transposeValue !== null) {
            isTransposeOn = _transposeValue.toString().trim() === 'On';
          }
        } catch {}
      }

      // Stacked bar charts: UNCHANGED original behaviour — metrics are the stack
      // layers by default (transpose OFF, per-metric colour). When transpose is ON,
      // brands become the stack layers (colour by colChild/brand).
      // Cluster bar charts (and ONLY cluster bars): when transposed each metric is a
      // series, so colour per metric; when not transposed each brand is a series, so
      // keep the original brand colouring.
      const isClusterBar = widget.widgetchart_name === 'Vertical Cluster Bar' ||
                           widget.widgetchart_name === 'Horizontal Cluster Bar';
      const isStackBar = widget.widgetchart_name === 'Vertical Stack Bar' ||
                         widget.widgetchart_name === 'Horizontal Stack Bar';
      const isPieChartWidget = widget.widgetchart_name === '01/PIE CHART' ||
                               widget.widgetchart_name === '05/PIE CHART' ||
                               widget.widgetchart_name === '09/PIE CHART';
      // 05 pie draws one ring per metric. A brand/cohort key paints every ring the same colour.
      const isRingPie = widget.widgetchart_name === '05/PIE CHART';
      const usePerMetricColoring = isClusterBar ? isTransposeOn : (isStackBar ? !isTransposeOn : false);

      // Only cluster bars flatten across metric groups; every other chart (incl. stack)
      // keeps the original single-group behaviour.
      const metricValues = isClusterBar
        ? widget.metric.flatMap((mg: any) => mg.metric_value || [])
        : widget.metric[0].metric_value;

      if (isStackBar) {
        this.buildStackBarColorMap(widget, metricValues, isTransposeOn, widgetColorMap, widgetColorMapLinearGradient);
      }

      metricValues.forEach((metricValue: any) => {
        metricValue.data = metricValue.data.map((entry: any) => {
          const colChild = entry.colChild;
          const rowChild = entry.rowChild;
          let colorKey: string;
          const isSingleOrAudience = this._configService.selectedSnapshotType == 'Single Brand' || 
               this._configService.selectedSnapshotType == 'Audience Snapshot';

          if (isStackBar && !this.isRenderableStackBarEntry(entry)) {
            return entry;
          }
          // The additional KPI is rendered as a grey overlay marker instead of a stack layer,
          // so it must not claim a palette colour from the layers.
          if (isStackBar && metricValue.isAdditionalKPI) {
            return entry;
          }

          if (isRingPie) {
            // Each ring is a metric, so the key must change with the metric even when the brand does not.
            colorKey = metricValue.option || rowChild || colChild;
          } else if (isPieChartWidget) {
            // Pie slices represent brands/categories, so keep their colors tied to colChild.
            colorKey = colChild;
          } else if (usePerMetricColoring) {
            // Non-transposed stacked bar: each metric series needs its own color.
            // Use metric option as key so all brands within the same metric share one color.
            colorKey = rowChild || colChild;
          } else if (isStackBar && isTransposeOn) {
            // Transposed stack bar: each segment (colChild) is a stack layer and needs
            // its own color. Keep this even for Single Brand/Audience snapshots, where
            // rowChild would otherwise collapse every segment to a single colour.
            colorKey = colChild;
          } else if (isSingleOrAudience) {
            colorKey = colChild;
          } else if (isSingleOrAudience) {
            colorKey = `${rowChild}`;
          } else {
            colorKey = colChild;
          }

          // Assign colorKey FIRST so the displayed color always claims the lowest slot
          if (!widgetColorMap[colorKey]) {
            if (isStackBar) {
              // buildStackBarColorMap already resolved every layer of this widget; this only
              // covers a key it could not see.
              widgetColorMap[colorKey] = entry.color || this.getFilteredColor(widgetColorIndex);
              widgetColorMapLinearGradient[colorKey] = this.getStableStackBarGradient(widget, colorKey, entry.colorLinearGradient, widgetColorIndex);
              widgetColorIndex++;
            } else if (!isRingPie && entry.color) {
              widgetColorMap[colorKey] = entry.color;
              widgetColorMapLinearGradient[colorKey] =
                entry.colorLinearGradient || this.linearGradientsColorPalette[widgetColorIndex % this.linearGradientsColorPalette.length];
              widgetColorIndex++;
            } else if (this.globalColorMap[colorKey]) {
              widgetColorMap[colorKey] = this.globalColorMap[colorKey];
              widgetColorMapLinearGradient[colorKey] = this.globalColorMapLinearGradient[colorKey];
            } else {
              widgetColorMap[colorKey] = this.getFilteredColor(widgetColorIndex);
              widgetColorMapLinearGradient[colorKey] = this.linearGradientsColorPalette[widgetColorIndex % this.linearGradientsColorPalette.length];
              widgetColorIndex++;
            }
          }

          const color = (isStackBar || isRingPie) ? widgetColorMap[colorKey] : entry.color || widgetColorMap[colorKey];
          const colorLinearGradient = (isStackBar || isRingPie) ? widgetColorMapLinearGradient[colorKey] : entry.colorLinearGradient || widgetColorMapLinearGradient[colorKey];

          let data = entry.data;
          let data2 = entry.data2;
          if (entry.CalculationType?.toLowerCase() === 'meanpercentage') {
            data = data == null || data === 'NA' ? data : data * 100;
            data2 = data2 == null || data2 === 'NA' ? data2 : data2 * 100;
          }

          return {
            ...entry,
            data,
            data2,
            color,
            colorLinearGradient,
          };
        });
      });
      // Merge widget-local assignments into global map for legend compatibility
      Object.assign(this.globalColorMap, widgetColorMap);
      Object.assign(this.globalColorMapLinearGradient, widgetColorMapLinearGradient);
    });
    
    // publish global maps to SnapshotService so other components (charts) can consume them
    this._configService.setGlobalColorMap(this.globalColorMap);
    this._configService.setGlobalColorMapLinearGradient(this.globalColorMapLinearGradient);
    
    console.log('widgetOutput',items);
     this._configService.allPageOutputData=items;
      if (typeof window !== undefined) {
        (window as any)['jsonobject'] = items;
      }
      
    // Emit the updated globalColorMap to parent component
    this.globalColorMapChanged.emit(this.globalColorMap);
    items.forEach((w: any) => { w.legendItems = this.getLegendItems(w); w.legendTable = this.getLegendTable(w); });
    return items;
  }

  updateDataBars(item: any, status: boolean) {
    item.enableDataBars = status;
    const props = JSON.parse(item.customizationProperties || '{}');
    props.enableDataBars = status;
    item.customizationProperties = JSON.stringify(props);
    item.toggleButton = false;
    setTimeout(() => (item.toggleButton = true));
  }

  //----------Handling pagination counter---------
  pageCount = 1;
  disableLeftClick = false;
  disableRightClick = false;
  Paginate(side: string) {
    if (side == 'left') {
      const newPageData = { page: this.pageCount, data: this.data }; // Replace with your page and data
      const pageIndex = this.outputPageData.findIndex(
        (item: any) => item.page === newPageData.page
      );
      if (pageIndex !== -1) {
        // Page exists, update the data
        this.outputPageData[pageIndex].data = newPageData.data;
      } else {
        // Page does not exist, append the new entry
        this.outputPageData.push(newPageData);
      }
      if (this.pageCount == 2) {
        this.pageCount--;
        this.createInitialChartList();
        // this.data = this._configService.selectedcompareacrossOption.includes("Multiple") ? this.paginatedDataMultiple() : this.paginatedData();
        let isPage = this.outputPageData.findIndex(
          (item: any) => item.page === this.pageCount
        );
        if (isPage == -1) {
          this.data = this._configService.selectedcompareacrossOption.includes(
            'Multiple'
          )
            ? this.paginatedDataMultiple()
            : this.paginatedData();
        } else {
          this.data = this.outputPageData[isPage].data;
        }
        this.disableLeftClick = true;
        this.disableRightClick = false;
      } else {
        this.disableLeftClick = false;
        this.disableRightClick = false;
        this.pageCount--;
        this.createInitialChartList();
        // this.data = this._configService.selectedcompareacrossOption.includes("Multiple") ? this.paginatedDataMultiple() : this.paginatedData();
        let isPage = this.outputPageData.findIndex(
          (item: any) => item.page === this.pageCount
        );
        if (isPage == -1) {
          this.data = this._configService.selectedcompareacrossOption.includes(
            'Multiple'
          )
            ? this.paginatedDataMultiple()
            : this.paginatedData();
        } else {
          this.data = this.outputPageData[isPage].data;
        }
      }
    } else if (side == 'right') {
      // if (this.pageCount == (Math.ceil(this.totalNumberOfCharts / this.columnPerRowCount) - 1)) {
      const newPageData = { page: this.pageCount, data: this.data }; // Replace with your page and data
      const pageIndex = this.outputPageData.findIndex(
        (item: any) => item.page === newPageData.page
      );
      if (pageIndex !== -1) {
        // Page exists, update the data
        this.outputPageData[pageIndex].data = newPageData.data;
      } else {
        // Page does not exist, append the new entry
        this.outputPageData.push(newPageData);
      }
      if (this.pageCount == this.pagesConfiguredFromLayout - 1) {
        this.pageCount++;
        this.createInitialChartList();
        this.disableRightClick = true;
        let isPage = this.outputPageData.findIndex(
          (item: any) => item.page === this.pageCount
        );
        if (isPage == -1) {
          this.data = this._configService.selectedcompareacrossOption.includes(
            'Multiple'
          )
            ? this.paginatedDataMultiple()
            : this.paginatedData();
        } else {
          this.data = this.outputPageData[isPage].data;
        }
        this.disableLeftClick = false;
      } else {
        this.pageCount++;
        this.createInitialChartList();
        this.disableLeftClick = false;
        this.disableRightClick = false;
        // this.data = this._configService.selectedcompareacrossOption.includes("Multiple") ? this.paginatedDataMultiple() : this.paginatedData();
        let isPage = this.outputPageData.findIndex(
          (item: any) => item.page === this.pageCount
        );
        if (isPage == -1) {
          this.data = this._configService.selectedcompareacrossOption.includes(
            'Multiple'
          )
            ? this.paginatedDataMultiple()
            : this.paginatedData();
        } else {
          this.data = this.outputPageData[isPage].data;
        }
      }
    }

    this.pageCounterChanged.emit(this.pageCount);
    if (
      this.data.length == 1 &&
      this.data[0].widgetchart_name == 'FUNNEL CHART'
    ) {
      this.prepareGridForMultiFunnel(this.data[0]);
    }
    return;
  }

  updateNavigationButtonsState() {
    // Enable/disable navigation buttons based on pageCount
    this.disableLeftClick = this.pageCount <= 1; // Disable left if on the first page
    this.disableRightClick = this.pageCount >= this.pagesConfiguredFromLayout; // Disable right if on the last page
  }

  getIconComponentById(globalId: number): CustomOutputIconsComponent | undefined {
    return this.iconComponents?.find(c => c.id === globalId);
  }

  getGlobalIconId(localIndex: number): number {
  let offset = 0;
  for (let p = 0; p < this.pageCount - 1; p++) {
    offset += this.datafromLayout[p]?.selectedLayout ?? 0;
  }
  return offset + localIndex;
}

  // elementClickedStatus(event: any) {
  //   const updatedData = this.data.map((d: any) => {
  //     if (d == event.data) {
  //       if (event.key == "sort") {
  //         if(event.value=="ascending"){
  //           d.metric.forEach((dd:any)=>{
  //             dd.metric_value[0].data.sort((a:any, b:any) => a.data - b.data);
  //           })
  //         }
  //       }
  //       else {
  //         let m = JSON.parse(d.customizationProperties);
  //         m[event.key] = event.value;
  //         return {
  //           ...d,
  //           customizationProperties: JSON.stringify(m),
  //         };
  //       }
  //     }
  //     return d;
  //   });
  //   this.data = [...updatedData];
  // }

  originalData: any[] = [..._.cloneDeep(this.data)]; // Initialize with the original data

  elementClickedStatus(event: any) {
    const updatedData = this.data.map((d: any) => {
      if (d === event.data) {
        if (event.key === 'sort' && d.widgetchart_name != 'Table') {
          const customizationProps = JSON.parse(
            d.customizationProperties || '{}'
          );
          customizationProps[event.key] = event.value;
          if (event.value === 'ascending' || event.value === 'descending') {
            if (
              this._configService.selectedSnapshotType
                .toLowerCase()
                .includes('multi')
            ) {
              return {
                ...d,
                customizationProperties: JSON.stringify(customizationProps),
                metric: d.metric.map((dd: any) => ({
                  ...dd,
                  metric_value: dd.metric_value.map((mv: any) => ({
                    ...mv,
                    data: [...mv.data].sort((a: any, b: any) =>
                      event.value === 'ascending'
                        ? a.data - b.data
                        : b.data - a.data
                    ),
                  })),
                })),
              };
            } else {

              return {
                ...d,
                customizationProperties: JSON.stringify(customizationProps),
                metric: d.metric.map((dd: any) => {
                  // Sort the metric_value items based on the first item in the data array
                  const sortedMetricValue = [...dd.metric_value].sort(
                    (a: any, b: any) => {
                      const aData = a.data[0]?.data; // Access the 'data' key of the first item in the data array
                      const bData = b.data[0]?.data; // Same for b

                      // Check if both aData and bData exist and compare them, else default to 0
                      if (aData !== undefined && bData !== undefined) {
                        return event.value === 'ascending'
                          ? aData - bData
                          : bData - aData; // Ascending order based on the 'data' value
                      }
                      return 0; // Default to no sort if comparison cannot be made
                    }
                  );

                  return {
                    ...dd,
                    metric_value: sortedMetricValue, // Set the sorted metric_value array
                  };
                }),
              };
            }
          } else if (event.value === 'default') {
            // Restore the original data for this specific item
            return {
              ...d,
              customizationProperties: JSON.stringify(customizationProps),
              metric: d.metric.map((dd: any) => ({
                ...dd,
                metric_value: dd.metric_value.map((mv: any) => ({
                  ...mv,
                  data: [...mv.data].sort(
                    (a: any, b: any) => a.defaultIndex - b.defaultIndex
                  ), // Sort by 'defaultIndex'
                })),
              })),
            };
          }
        } else {
          // Handle customizationProperties updates
          const customizationProps = JSON.parse(
            d.customizationProperties || '{}'
          );
          customizationProps[event.key] = event.value;
          return {
            ...d,
            customizationProperties: JSON.stringify(customizationProps),
          };
        }
      }
      return d;
    });
    let globalColorIndex: number = Object.keys(this.globalColorMap).length;
    updatedData.forEach((widget: any) => {
      if (!widget.widget_name || !widget.metric || widget.metric.length === 0)
        return;

      const metricValues = widget.metric[0].metric_value;

      metricValues.forEach((metricValue: any) => {
        metricValue.data = metricValue.data.map((entry: any) => {
          const colChild = entry.colChild;
          const rowChild = entry.rowChild;
          let colorKey = colChild;
          if (this._configService.selectedSnapshotType == 'Single Brand' || 
               this._configService.selectedSnapshotType == 'Audience Snapshot') {
            colorKey = `${colChild}__${rowChild}`;
          }

          // Assign color if not already mapped
          if (!this.globalColorMap[colorKey]) {
            if (entry.color) {
              this.globalColorMap[colorKey] = entry.color;
              this.globalColorMapLinearGradient[colorKey] =
                entry.colorLinearGradient || this.linearGradientsColorPalette[globalColorIndex % this.linearGradientsColorPalette.length];
              globalColorIndex++;
            } 
            else {
            this.globalColorMap[colorKey] = this.getFilteredColor(globalColorIndex);
            this.globalColorMapLinearGradient[colorKey] =
              this.linearGradientsColorPalette[globalColorIndex % this.linearGradientsColorPalette.length];
            globalColorIndex++;
          }
          }
          const color = entry.color || this.globalColorMap[colorKey];
          const colorLinearGradient =
            entry.colorLinearGradient || this.globalColorMapLinearGradient[colorKey];
          return {
            ...entry,
            color,
            colorLinearGradient,
          };
        });
      });
    });
    this.data = [...updatedData];
    this._configService.newCustomizationData = this.data;
  }

  multimetricselect: boolean = false;
  gridData: any[] = [];
  getAudienceDisplayLabel(colChild: string, allColChilds: string[]): string {
    if (!colChild || !colChild.includes('|')) { return colChild; }
    const parts = colChild.split('|');
    const last = parts[parts.length - 1];
    const dupCount = (allColChilds || []).filter((c: string) => {
      if (!c || !c.includes('|')) { return c === last; }
      const p = c.split('|');
      return p[p.length - 1] === last;
    }).length;
    if (dupCount > 1 && parts.length >= 2) {
      return parts[parts.length - 2] + ' | ' + last;
    }
    return last;
  }
  prepareGridForMultiFunnel(customData: any) {
    const isAudienceSnapshot = this._configService.selectedSnapshotType.toLowerCase().includes('audience') && this._configService.multiCohort;
    const allColChilds = customData.metric[0].metric_value[0].data.map((d: any) => d.colChild);
    customData.metric[0].metric_value[0].data.forEach((d: any) => {
      // For audience snapshot, show the audience display label (handles duplicate last-level options)
      let headerValue = d.colChild;
      if (isAudienceSnapshot && d.colChild && d.colChild.includes('|')) {
        headerValue = this.getAudienceDisplayLabel(d.colChild, allColChilds);
      }
      this.gridData.push({
        header: headerValue,
        data: customData,
      });
    });
  }

  OnInsigthsbuttonClick() {
    this.arktabaccess = true;
    let data = [];
    this.InsightsResponse = [];
    let ShareColumn =
      this.selectedDataFormat != 'Respondent Level'
        ? 'value'
        : this.isTotalBase
        ? this.selectedWeight == 'Unweighted'
          ? 'totalUnweightedShare'
          : 'totalWeightedShare'
        : this.selectedWeight == 'Unweighted'
        ? 'answerUnweightedShare'
        : 'answerWeightedShare';
    let BaseColumn = this.isTotalBase
      ? 'totalUnweightedBase'
      : 'answerUnweightedBase';
    this.apiService
      .getInsightsData(
        this.isIndex,
        this.outputData,
        this.selected_study,
        this.selected_client,
        this.inforRibbon?.nativeElement.textContent,
        this.DefaultConfidenceLevel,
        ShareColumn,
        BaseColumn
      )
      .subscribe((result: string) => {
        // Response is valid
        // this.errorPopup(result, "Insights for the Generated Ouptput data")
        // let insightsData = JSON.parse(result.Data);
        // this.InsightsData = insightsData;
        this.isInsightspopupOpen = true;
        this.showSnapshot = true;
        // const insightsObj: InsightsModel = {
        //   header: 'Insights',
        //   message: result,
        //   show: true,
        // };
        const insightData = result
          .split('- ')
          .map((item) => item.trim())
          .filter((item) => item.length > 0);
        this.insightsVal = insightData;
        // Show the alert popup using the alert service
        this._insightsSerive.showInisghts(this.InsightsResponse);
        //hide the loader
        this.arktabaccess = false;
      });
  }

  closeGlobalDefaultPopup() {
    if (this.dontShowAgain) {
      localStorage.setItem('dontShowGlobalDefaultPopup', 'true');
    }
    this.showGlobalDefaultPopup = false;
    if (this.globalDefaultPopupTimeout) {
      clearTimeout(this.globalDefaultPopupTimeout);
      this.globalDefaultPopupTimeout = null;
    }
  }
  

  onChartScroll(event: WheelEvent, index: number) {
    
 
if (this.noDataAvailable) {
    event.preventDefault();
    event.stopPropagation();
    return;
  }

    // A trackpad swipe reports its horizontal travel in deltaX, and every branch below can only
    // consume deltaY. Swallowing such an event leaves the widget's own horizontal scrollbar
    // frozen, so hand the gesture back to the browser instead.
    if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
      return;
    }

    const target = event.target as HTMLElement;
    const insightContainer = document.getElementById(`insight-${index}`);

    if (!insightContainer) return;

    // Detect which container the scroll event originated from
    const scrollContainer = this.getScrollContainer(target);

    // Detect scroll direction
    const scrollDirection = this.getScrollDirection(event.deltaY);

    // Find if there's any scrollable element within the chart container
    const scrollableElement = this.findScrollableElement(target);
    const hasChartScrollableContent = scrollableElement !== null;
    const hasTextScrollableContent = this.hasScrollableContent(insightContainer);

    // Scenario 4: If scroll is neither on chart or text container, enable default browser scroll
    if (scrollContainer === 'unknown') {
      return; // Enable default browser scroll
    }

    // Scenarios for CHART CONTAINER scrolling
    if (scrollContainer === 'chart') {
      if (hasChartScrollableContent) {
        const isChartAtLimit = this.isAtScrollLimit(scrollableElement, event.deltaY);

        if (scrollDirection === 'down' && isChartAtLimit) {
          // Scenario 1: Chart scrolling down and reached bottom limit
          if (hasTextScrollableContent) {
            const isTextAtBottomLimit = this.isAtScrollLimit(insightContainer, event.deltaY);
            if (isTextAtBottomLimit) {
              // Text also at bottom limit, enable browser scroll down
              return;
            } else {
              // Text can scroll down, scroll the text container
              event.preventDefault();
              event.stopPropagation();
              this.smoothScrollInsight(insightContainer, event);
            }
          } else {
            // No text scrollable content, enable browser scroll down
            return;
          }
        } else if (scrollDirection === 'up' && isChartAtLimit) {
          // Scenario 3: Chart scrolling up and reached top limit
          // Enable browser scroll up regardless of text container state
          return;
        } else {
          // Chart can still scroll
          event.preventDefault();
          event.stopPropagation();
          scrollableElement.scrollTop += this.normalizeScrollDelta(event);
        }
      } else {
        // No chart scrollable content, check text container
        if (hasTextScrollableContent) {
          const isTextAtLimit = this.isAtScrollLimit(insightContainer, event.deltaY);
          if (isTextAtLimit) {
            // Text at limit, enable browser scroll
            return;
          } else {
            // Text can scroll
            event.preventDefault();
            event.stopPropagation();
            this.smoothScrollInsight(insightContainer, event);
          }
        } else {
          // No scrollable content in either, enable browser scroll
          return;
        }
      }
    }

    // Scenarios for TEXT CONTAINER scrolling
    else if (scrollContainer === 'text') {
      if (hasTextScrollableContent) {
        const isTextAtLimit = this.isAtScrollLimit(insightContainer, event.deltaY);

        if (scrollDirection === 'down' && isTextAtLimit) {
          // Scenario 5: Text scrolling down and reached bottom limit
          if (!hasChartScrollableContent) {
            // No chart scrollable content, enable browser scroll down
            return;
          } else {
            // Chart has scrollable content, but text reached bottom - enable browser scroll
            return;
          }
        } else if (scrollDirection === 'up' && isTextAtLimit) {
          // Scenario 6: Text scrolling up and reached top limit
          if (hasChartScrollableContent) {
            // Check if chart is at top limit
            const isChartAtTopLimit = this.isAtScrollLimit(scrollableElement, -1); // Check for up direction
            if (isChartAtTopLimit) {
              // Chart also at top limit, enable browser scroll up
              return;
            } else {
              // Chart can scroll up, scroll the chart container
              event.preventDefault();
              event.stopPropagation();
              scrollableElement.scrollTop += this.normalizeScrollDelta(event);
            }
          } else {
            // No chart scrollable content, enable browser scroll up
            return;
          }
        } else {
          // Text can still scroll
          event.preventDefault();
          event.stopPropagation();
          this.smoothScrollInsight(insightContainer, event);
        }
      } else {
        // No text scrollable content, enable browser scroll
        return;
      }
    }
  }

  private getDetailedScrollInfo(target: HTMLElement): {
    container: 'chart' | 'text' | 'unknown';
    elementType: string;
    className: string;
  } {
    const container = this.getScrollContainer(target);

    return {
      container: container,
      elementType: target.tagName.toLowerCase(),
      className: target.className || 'no-class'
    };
  }

  private getScrollContainer(target: HTMLElement): 'chart' | 'text' | 'unknown' {
    // Check if the target element or its parents are within chart container
    const chartContainer = target.closest('.chart') || target.closest('.chart_expand');
    if (chartContainer) {
      return 'chart';
    }

    // Check if the target element or its parents are within text container (insight)
    const textContainer = target.closest('.insight');
    if (textContainer) {
      return 'text';
    }

    return 'unknown';
  }

  private getScrollDirection(deltaY: number): 'up' | 'down' | 'none' {
    if (deltaY > 0) {
      return 'down'; // Scrolling down
    } else if (deltaY < 0) {
      return 'up'; // Scrolling up
    } else {
      return 'none'; // No scroll
    }
  }

  private hasScrollableContent(element: HTMLElement): boolean {
    // Check if element has scrollable content (content height > visible height)
    return element.scrollHeight > element.clientHeight;
  }

  private findScrollableElement(target: HTMLElement): HTMLElement | null {
    // Look for scrollable elements in the chart container hierarchy
    let element = target;

    while (element) {
      if (this.hasScrollableContent(element)) {
        return element;
      }

      // Check parent elements up to chart container
      if (element.closest('.chart') || element.closest('.chart_expand')) {
        element = element.parentElement as HTMLElement;
        if (!element) break;
      } else {
        break;
      }
    }

    return null;
  }

  private isAtScrollLimit(element: HTMLElement, deltaY: number): boolean {
    // Check if element has scrollable content first
    if (element.scrollHeight <= element.clientHeight) {
      // No scrollable content, consider it always at limit
      return true;
    }

    const tolerance = 3; // Small tolerance for better detection

    if (deltaY > 0) {
      // Scrolling down - check if at bottom
      const scrollTop = Math.round(element.scrollTop);
      const clientHeight = Math.round(element.clientHeight);
      const scrollHeight = Math.round(element.scrollHeight);
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - tolerance;
      return isAtBottom;
    } else if (deltaY < 0) {
      // Scrolling up - check if at top (start)
      const scrollTop = Math.round(element.scrollTop);
      const isAtTop = scrollTop <= tolerance;
      return isAtTop;
    }

    return false; // No scroll direction detected
  }

  private normalizeScrollDelta(event: WheelEvent): number {
    switch (event.deltaMode) {
      case 1: // DOM_DELTA_LINE - mouse wheel (lines); convert to pixels
        return event.deltaY * 20;
      case 2: // DOM_DELTA_PAGE - convert pages to pixels
        return event.deltaY * window.innerHeight;
      default: // DOM_DELTA_PIXEL (0) - trackpad; deltaY is already in pixels
        return event.deltaY;
    }
  }

  private smoothScrollInsight(insightContainer: HTMLElement, event: WheelEvent) {
    const scrollAmount = this.normalizeScrollDelta(event);

    // Apply scroll with bounds checking
    const currentScrollTop = insightContainer.scrollTop;
    const maxScrollTop = insightContainer.scrollHeight - insightContainer.clientHeight;

    const newScrollTop = Math.max(0, Math.min(currentScrollTop + scrollAmount, maxScrollTop));

    insightContainer.scrollTop = newScrollTop;
  }

  private startGlobalDefaultPopupTimer() {
    // Clear any existing timer
    if (this.globalDefaultPopupTimeout) {
      clearTimeout(this.globalDefaultPopupTimeout);
    }
    this.globalDefaultPopupTimeout = setTimeout(() => {
      // Auto-dismiss only if still visible
      if (this.showGlobalDefaultPopup) {
        this.showGlobalDefaultPopup = false;
        this._cdr.detectChanges();
      }
      this.globalDefaultPopupTimeout = null;
    }, 7000); // 7 seconds
  }

  ngOnDestroy(): void {
    if (this.globalDefaultPopupTimeout) {
      clearTimeout(this.globalDefaultPopupTimeout);
    }
    if (this._sectionRefreshTimer) {
      clearTimeout(this._sectionRefreshTimer);
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this._decimalConfigSub) {
      this._decimalConfigSub.unsubscribe();
    }
  }
 isTrendWidgetDataReady(item: any): boolean {
    return item?.metric?.[0]?.metric_value?.some((mv: any) => Array.isArray(mv.data) && mv.data.length > 0) === true;
  }

 getSelectedBrandLabel(item: any): string {
  // If audience is NOT null, return empty string
  if (item?.audience != null ) {
    return '';
  }

  const value =
    this._configService?.finalLeftPanelSubmitObject?.previewData
      ?.Audiencebrand?.[0]?.option;

  if (!value) {
    return '';
  }
  const rawBrandName = value.split('|').pop() ?? value;
  const brandName = `(${rawBrandName})`;
  return brandName;
}

// getLegendItems(item: any): Array<{ name: string; color: string; isKPI: boolean }> {
//   if (!item?.metric?.[0]?.metric_value) return [];
//   const all = item.metric[0].metric_value.map((mv: any) => {
//     const colorKey = Object.keys(this.globalColorMap).find(k => k === mv.option || k.includes(mv.option)) ?? '';
//     return { name: mv.option || '', color: this.globalColorMap[colorKey] || '#aaa', isKPI: !!mv.isAdditionalKPI };
//   });
//   // KPI items first, then regular series
//   return [...all.filter((x: any) => x.isKPI), ...all.filter((x: any) => !x.isKPI)];
// }
getLegendItems(item: any): Array<{ name: string; color: string; isKPI: boolean }> {
  if (!item?.metric?.[0]?.metric_value) return [];

  // Check if Transpose/StackFormat is ON
  let isTransposed = false;
  if (item.customizationProperties) {
    try {
      const props = JSON.parse(item.customizationProperties);
      const sf = (props.StackFormat || props.Transpose || props.additionalGroup?.Transpose || '').toString().trim();
      isTransposed = sf === 'On';
    } catch {}
  }
  if (!isTransposed && item.stackFormat) {
    isTransposed = item.stackFormat.toString().trim() === 'On';
  }

  // For transposed stacked bar charts, use brand names (colChild) instead of metric names
  if (isTransposed && (item.widgetchart_name === 'Vertical Stack Bar' || item.widgetchart_name === 'Horizontal Stack Bar')) {
    const brandSet = new Set<string>();
    const brandItems: Array<{ name: string; color: string; isKPI: boolean }> = [];
    item.metric[0].metric_value.forEach((mv: any) => {
      (mv.data || []).forEach((d: any) => {
        const rawName = d.colChild || '';
        const cleanedName = rawName.includes('|') ? rawName.split('|').pop()!.trim() : rawName.trim();
        if (cleanedName && !brandSet.has(cleanedName)) {
          brandSet.add(cleanedName);
          brandItems.push({
            name: cleanedName,
            color: d.color || this.globalColorMap[rawName] || this.globalColorMap[cleanedName] || '#aaa',
            isKPI: false
          });
        }
      });
    });
    return brandItems;
  }
if (item.widgetchart_name === 'Vertical Cluster Bar' || 
    item.widgetchart_name === 'Horizontal Cluster Bar') {

  let isClusterTransposed = false;
  try {
    const props = JSON.parse(item.customizationProperties || '{}');
    isClusterTransposed = (props.StackFormat ?? '').toString().trim() === 'On';
  } catch {}

  if (isClusterTransposed) {
    const globalColorValues = Object.values(this.globalColorMap);
  const seen = new Set<string>();
    const clusterItems: Array<{ name: string; color: string }> = [];

    // Transposed cluster bars colour per metric; metrics can span multiple groups.
    const allMetricValues = (item.metric || []).flatMap((mg: any) => mg.metric_value || []);
    allMetricValues.forEach((mv: any, seriesIdx: number) => {
      const name = (mv.option || '').trim();
      if (name && !seen.has(name)) {
        seen.add(name);
        const color = mv.data?.[0]?.color
          || (globalColorValues.length > 0
            ? globalColorValues[seriesIdx % globalColorValues.length]
            : '#aaa');
        clusterItems.push({ name, color });
      }
    });
    return clusterItems as any;

  } else {
    const seen = new Set<string>();
    const clusterItems: Array<{ name: string; color: string }> = [];

  item.metric[0].metric_value.forEach((mv: any) => {
    (mv.data || []).forEach((d: any) => {
      const rawName = d.colChild || '';
      const cleanedName = rawName.includes('|') 
          ? rawName.replace(/\|[Yy]es$/i, '').split('|').pop()!.trim()
        : rawName.trim();
      
      if (cleanedName && !seen.has(cleanedName)) {
        seen.add(cleanedName); 
        const colorKey = Object.keys(this.globalColorMap).find(
          k => k === rawName || k === cleanedName || k.includes(cleanedName)
        ) ?? '';
        clusterItems.push({
          name: cleanedName,
            color: d.color || this.globalColorMap[colorKey] || '#aaa'
        });
      }
    });
  });
    return clusterItems as any;
}
}
  // Legends: use metric names; read color directly from data entries for per-widget accuracy
  const isPieChart = item.widgetchart_name === '05/PIE CHART' ||
    item.widgetchart_name === '01/PIE CHART' ||
    item.widgetchart_name === '09/PIE CHART';
  const isStackedBar = item.widgetchart_name === 'Vertical Stack Bar' || item.widgetchart_name === 'Horizontal Stack Bar';
  const all = item.metric[0].metric_value.filter((mv: any) => {
      if (!isPieChart) return true;
      const firstData = mv.data?.[0];
      if (!firstData || firstData.data == null) return true;
      const calcType = (firstData.CalculationType || '').toLowerCase();
      const isPercentage = calcType === 'share' || calcType === 'respgrp';
      const numVal = isPercentage ? firstData.data * 100 : Number(firstData.data);
      return isNaN(numVal) || numVal >= 0;
    })
    .map((mv: any, index: number) => {
    const optionColor = mv.option ? this.globalColorMap[mv.option] : undefined;
    const dataColor = (mv.data || []).find((d: any) => !!d?.color)?.color;
    // Stack layers read their own widget colour first: globalColorMap is shared across
    // widgets, so a metric used by two widgets reports the other widget's colour there.
    const resolvedColor = isStackedBar ? dataColor || optionColor : optionColor || dataColor;
    const color = resolvedColor || this.getFilteredColor(index) || '#aaa';
    return { name: mv.option || '', color, isKPI: !!mv.isAdditionalKPI };
  });

  // For stacked bar charts, hide metrics whose all values are negative (they are hidden in the chart too)
  const filtered = isStackedBar
    ? all.filter((_: any, idx: number) => {
        const mv = item.metric[0].metric_value[idx];
        return (mv.data || []).some((d: any) => {
          const v = parseFloat(d.data);
          return !isNaN(v) && v > 0;
        });
      })
    : all;

  return [...filtered.filter((x: any) => x.isKPI), ...filtered.filter((x: any) => !x.isKPI)];
}

// Builds a cohort x legend table (cohort titles as columns, legend names as rows) for the
// '05/PIE CHART' widget when rendered in multi-cohort mode. Returns null when not applicable,
// so the legend dropdown falls back to the regular flat list for everyone else.
getLegendTable(item: any): { cohorts: string[]; rows: Array<{ name: string; color: string; values: { [cohort: string]: string } }> } | null {
  const PIE_LEGEND_TABLE_CHARTS = ['05/PIE CHART', '01/PIE CHART', '09/PIE CHART'];
  if (!PIE_LEGEND_TABLE_CHARTS.includes(item?.widgetchart_name)) return null;
  if (this._configService.outputSnapshotData?.audienceCohortType !== 'multiple') return null;
  if (!item?.metric?.[0]?.metric_value) return null;

  const metricValues = item.metric[0].metric_value;
  const cohortOf = (colChild: string) => {
    const parts = (colChild || '').split('|').map((p: string) => p.trim()).filter(Boolean);
    if (!parts.length) return '';
    return parts[parts.length - 1];
  };

  const cohorts: string[] = [];
  metricValues.forEach((mv: any) => {
    (mv.data || []).forEach((d: any) => {
      const cohort = cohortOf(d.colChild);
      if (cohort && !cohorts.includes(cohort)) cohorts.push(cohort);
    });
  });
  if (cohorts.length < 2) return null;

  // 05/PIE CHART draws one ring per metric within every cohort, so its colours follow the metric
  // order in the palette. The colour carried on the data is keyed by cohort and would make all
  // rings of a cohort identical.
  const ringOrder: string[] | null = item.widgetchart_name === '05/PIE CHART'
    ? metricValues
        .filter((mv: any) => !mv.isInnerCircle)
        .slice()
        .sort((a: any, b: any) => (a.selectorder ?? 0) - (b.selectorder ?? 0))
        .map((mv: any) => mv.option)
    : null;

  const rows = metricValues.map((mv: any, index: number) => {
    let color: string;
    if (ringOrder) {
      const ringIndex = ringOrder.indexOf(mv.option);
      color = this.getFilteredColor(ringIndex >= 0 ? ringIndex : index) || '#aaa';
    } else {
      // Prefer option-keyed color so all cohorts share the same metric color (matches pie chart slices)
      const optionColor = mv.option ? this.globalColorMap[mv.option] : undefined;
      const dataColor = (mv.data || []).find((d: any) => !!d?.color)?.color;
      color = optionColor || dataColor || this.getFilteredColor(index) || '#aaa';
    }
    const values: { [cohort: string]: string } = {};
    cohorts.forEach((cohort) => {
      const entry = (mv.data || []).find((d: any) => cohortOf(d.colChild) === cohort);
      if (entry && entry.data != null && entry.data !== 'NA') {
        const isPercentage = entry.CalculationType?.toLowerCase() === 'share' || entry.CalculationType?.toLowerCase() === 'respgrp';
        const value = isPercentage ? entry.data * 100 : entry.data;
        values[cohort] = Math.round(value) + (isPercentage ? '%' : '');
      } else {
        values[cohort] = 'NA';
      }
    });
    return { name: mv.option || '', color, values };
  });

  return { cohorts, rows };
}

}
